import React from 'react';

const IconReport = ({ onClick }) => {
	return (
		<div className='IconReport' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_408_1319)">
					<path d="M3.33335 4.99984H1.66669V16.6665C1.66669 17.5832 2.41669 18.3332 3.33335 18.3332H15V16.6665H3.33335V4.99984ZM16.6667 1.6665H6.66669C5.75002 1.6665 5.00002 2.4165 5.00002 3.33317V13.3332C5.00002 14.2498 5.75002 14.9998 6.66669 14.9998H16.6667C17.5834 14.9998 18.3334 14.2498 18.3334 13.3332V3.33317C18.3334 2.4165 17.5834 1.6665 16.6667 1.6665ZM15.8334 9.1665H7.50002V7.49984H15.8334V9.1665ZM12.5 12.4998H7.50002V10.8332H12.5V12.4998ZM15.8334 5.83317H7.50002V4.1665H15.8334V5.83317Z" fill="#344054" />
				</g>
				<defs>
					<clipPath id="clip0_408_1319">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconReport;